var map = {
	"./alert.svg": [
		2343,
		2343
	],
	"./attachment-pin.svg": [
		3622,
		3622
	],
	"./avatars.svg": [
		1419,
		1419
	],
	"./back.svg": [
		3666,
		3666
	],
	"./book.svg": [
		3164,
		3164
	],
	"./calendar.svg": [
		625,
		625
	],
	"./calender.svg": [
		9237,
		9237
	],
	"./change.svg": [
		6643,
		6643
	],
	"./checked.svg": [
		8774,
		8774
	],
	"./class-teacher.svg": [
		7052,
		7052
	],
	"./class.svg": [
		3425,
		3425
	],
	"./clock-white.svg": [
		8099,
		8099
	],
	"./clock.svg": [
		4259,
		4259
	],
	"./close.svg": [
		1157,
		1157
	],
	"./completed-students.svg": [
		6911,
		6911
	],
	"./correct.svg": [
		3919,
		3919
	],
	"./delete.svg": [
		9226,
		9226
	],
	"./down-icon-dark.svg": [
		7884,
		7884
	],
	"./down-white.svg": [
		2179,
		2179
	],
	"./down.svg": [
		8723,
		8723
	],
	"./exclamation.svg": [
		4670,
		4670
	],
	"./expand.svg": [
		4807,
		4807
	],
	"./faq.svg": [
		3277,
		3277
	],
	"./feedback.svg": [
		1538,
		1538
	],
	"./file-upload.svg": [
		8265,
		8265
	],
	"./generate-report.svg": [
		2426,
		45
	],
	"./graduation-cap.svg": [
		7632,
		7632
	],
	"./green-tick.svg": [
		5530,
		5530
	],
	"./happy-emoji.svg": [
		1626,
		1626
	],
	"./left-arrow.svg": [
		1760,
		1760
	],
	"./logout.svg": [
		7386,
		5005
	],
	"./mail.svg": [
		7486,
		7486
	],
	"./menu.svg": [
		3546,
		3546
	],
	"./partial.svg": [
		6674,
		6674
	],
	"./plus.svg": [
		8483,
		8483
	],
	"./profile.svg": [
		4086,
		4086
	],
	"./quote.svg": [
		6145,
		6145
	],
	"./rating1.svg": [
		7717,
		7717
	],
	"./rating2.svg": [
		5286,
		5286
	],
	"./rating3.svg": [
		3319,
		3319
	],
	"./rating4.svg": [
		488,
		488
	],
	"./replace.svg": [
		1077,
		1077
	],
	"./reset.svg": [
		404,
		404
	],
	"./right-arrow-fill.svg": [
		355,
		355
	],
	"./right-arrow.svg": [
		4991,
		4991
	],
	"./right-indicator.svg": [
		1175,
		1175
	],
	"./rounded-close.svg": [
		669,
		669
	],
	"./rounded-cross.svg": [
		6565,
		6565
	],
	"./rounded-tick-dark.svg": [
		37,
		37
	],
	"./rounded-tick.svg": [
		3784,
		3784
	],
	"./search-icon-purple.svg": [
		3562,
		3562
	],
	"./search-icon.svg": [
		1091,
		1091
	],
	"./sparkle.svg": [
		139,
		139
	],
	"./star.svg": [
		6743,
		6743
	],
	"./suggestion.svg": [
		6563,
		6563
	],
	"./tick.svg": [
		6400,
		6400
	],
	"./timer.svg": [
		4370,
		4370
	],
	"./total-homework.svg": [
		6642,
		6642
	],
	"./trash.svg": [
		5251,
		5251
	],
	"./unchecked.svg": [
		4093,
		4093
	],
	"./warning-tick.svg": [
		741,
		741
	],
	"./wrong.svg": [
		5470,
		5470
	],
	"./zoom-in.svg": [
		1846,
		1846
	],
	"./zoom-out.svg": [
		2497,
		2497
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8270;
module.exports = webpackAsyncContext;